import React from "react";
import { Moon, Sun } from "react-feather";
import { useOptionalTheme } from "../../providers/ThemeProvider";
import { IconToggleButton } from "../atoms/IconToggleButton";
import { THEME_MODE_COPY } from "../themeMode.copy";

/** Header light/dark switch (renders nothing outside a ThemeProvider) wired to the app theme (pressed = dark). Persists via the theme provider. */
export const ThemeModeToggle: React.FC = () => {
  const themeContext = useOptionalTheme();
  if (!themeContext) return null;
  const { resolvedMode, toggleMode } = themeContext;
  const isDark = resolvedMode === "dark";
  return (
    <IconToggleButton
      icon={isDark ? <Sun size={18} /> : <Moon size={18} />}
      label={isDark ? THEME_MODE_COPY.switchToLight : THEME_MODE_COPY.switchToDark}
      pressed={isDark}
      onClick={toggleMode}
    />
  );
};

export default ThemeModeToggle;
